<!-- <template>

    <div>

        <v-card class="pa-3 yellow lighten-3" dense>       
              
         
            <v-toolbar class="py-0 my-0 mb-4" color="pa-3 yellow lighten-3">
                
                    <v-spacer></v-spacer> 

                    <v-toolbar-title class="my-0 py-0 text-center" style="color: red; font-weight: bold;">
                        Reserva de Material - Trazabilidad N° {{ datos.numerot }}
                    </v-toolbar-title>

                    <v-spacer></v-spacer> 
                    
                    <div>
                        <v-btn icon @click="imprimirPDF" color="primary">
                        <v-icon>mdi-printer</v-icon>
                        </v-btn>
                    </div>

            </v-toolbar>
           
              

              
            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                                
                <v-row  dense  class="py-0 my-0" >

                    <v-col cols="2" sm="2" md="2"  dense>
                        Fecha : {{ datos.fecha.slice(0, 10) }}
                    </v-col>
                    <v-col cols="4" sm="4" md="4" dense>
                        Cliente: {{ datos.cliente }}
                    </v-col>

                    <v-col  cols="4" sm="4" md="4"  dense class="text-right">
                       Orden Compra: {{ datos.oc }}
                    </v-col>
                </v-row> 
                <v-row>
                    <v-col cols="4" sm="4" md="4"  dense>
                        Protocolo :{{ datos.protocolo }}
                    </v-col>        
                     <v-col cols="4" sm="4" md="4"  dense>
                        Usuario :{{ datos.usuario }}
                    </v-col>
                </v-row>  

            </v-card>    

            <div></div>

            <v-card class="pa-2 yellow lighten-4 mb-4" dense >
                <v-row>
                    <v-col cols="12" sm="12" md="12">

                        <v-data-table
                            :headers="headers"
                            :items="desserts"
                            class="elevation-1"
                            dense
                            :items-per-page.sync="itemsPerPage"
                            :footer-props="{
                            itemsPerPageText: 'Items por página',
                            }"

                        ></v-data-table>

                    </v-col>
                </v-row>
                
            </v-card>

            <div></div>               
            <v-card class="pa-2 yellow lighten-4 mt-4" dense >
            
                <v-row>
                    <v-col cols="auto">
                        Observación: {{ datos.observa }}
                    </v-col>
                </v-row>
                
            </v-card>
           

            </v-card>

    </div>


  
  </template>
  
  <script>

  import readXlsFile from "read-excel-file";
  import Axios from "../../axios-auth-sistemas";

  import BuscadorClientes from "../Comercial/BuscadorClientes.vue"; 


  import moment from "moment";

  import jsPDF from "jspdf"; 
  import "jspdf-autotable";




  
  export default {

    name:'RemitoLink',

    data() {
      return {
        headers: [
         
        { text: "Serie", value: "serie" },
        { text: "Número", value: "numero" },  
        { text: "Número Recep.", value: "itemr" },        
        { text: "N° Pedido", value: "npedido" },
        { text: "Articulo", value: "articulo" },             
     
        ],
       
        excelData: [],
        codigoCli:'',
        nombreCli:'',
        cuitCli:'',
        showBuscadorCli:false,
        showFlags:'',
        CodigoSele:'',
        editMode:false,
        dessertAux:[],
        vAlert:'',
        activar:false,
        validacionExitosa: true, 
        fileInput:'',
        dialogCorreo:false,
        direcciones: [],
        direccion: "",
        correos: "",
        mailSel:"",
        vNumRto:'',
        vRtoGral:'',
        datos:{
            codigo:'',
            nombre:'',
            protocolo:'',
            numero:'',
            fecha:'',
            usuario:'',
            oc:'', 
            observa:'',           

        },
        desserts:[],
        visible:true,
        itemsPerPage:-1,




      };
    },


    computed: {

        show: {
            get() {        
    
            return this.visible;
            },
        } 

    },
    watch: {
        
       
    } ,   

    mounted() {

       console.log("estoy en remito link")
        this.vRtoGral = this.$route.query.codgral;
        this.cargarTrazabilidad(this.vRtoGral);

    },


    methods: { 

        salir(){
            this.visible=false;
        },

       cargarTrazabilidad(id){

            console.log("id", id)
            Axios
            .get("/Inspeccion/LinkTrazabilidad?", {
            params: {
                id: id                 
            },
            })
            .then((r) => { 

                console.log("datos",r.data)

                this.datos.cliente = r.data[0].cliente;
                this.datos.protocolo = r.data[0].protocolo==null ||  r.data[0].protocolo=='' ?'Sin Ensayos': r.data[0].protocolo;
                this.datos.oc = r.data[0].oc;
                this.datos.fecha = r.data[0].fecha;
                this.datos.usuario = r.data[0].usuario;
                this.datos.observa = r.data[0].observa;
                this.datos.numerot = r.data[0].numerot;
                

                r.data.forEach(element => {                   
                    
                    this.desserts.push({
                        numero: element.numero  ,
                        serie: element.serie  ,
                        itemr: element.itemr  ,
                        npedido: element.npedido  ,
                        articulo: element.articulo,
                        id:element.id,
                      

                    })
                });

              

               

                    
                    
                    
                    
            })
            .catch((error) => {
                console.log("no muestra el remmito cuando hace link")      
                
                            
            }); 



       },


       imprimirPDF(){

            var vm = this;      
            var columns = [

            {title: "Item", dataKey: "item"},
            {title: "Cantidad", dataKey: "cantidad"},  
            {title: "Articulo", dataKey: "articulo"},
            {title: "Camion", dataKey: "camion"},
            {title: "Descripcion", dataKey: "detalle"},           
                    
          
           


            ];
            var doc = new jsPDF();
            doc.setLineWidth(0.5);
            doc.line(10, 11, 200, 11);           
            doc.line(10, 11, 10, 41);
            doc.line(165, 24, 200, 24);
           // doc.line(165, 33, 200, 33);
            doc.addImage(
                "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",
                "JPEG",
                15,
                15,
                22,
                22
            );
            doc.setFontSize(13);
            doc.text("REMITO TEMPORAL" , 75, 20);

            doc.setFontSize(11);
            doc.text("CLIENTE: " + vm.datos.codigo + ' - ' + vm.datos.nombre   , 42, 30);

            doc.setFontSize(9);
            doc.text("O.COMPRA: " + vm.datos.ordencompra   , 42, 40);

            doc.setFontSize(9);
            doc.text("ENVIO: " + vm.datos.envio   , 90, 40);

            doc.setFontSize(9);
            doc.text("CANT. CAMIONES:  " + vm.datos.cantcamion   , 120, 40);

            doc.setFontSize(13);
            doc.text("N° " + vm.datos.numero , 166, 20);
                 
           
            doc.setFontSize(10);
            doc.text(vm.datos.fecha.slice(0,10) , 166, 30);
       
           
            doc.line(40, 11, 40, 41);
            doc.line(165, 11, 165, 41);
            doc.line(10, 41, 200, 41);
            doc.line(200, 11, 200, 41);
            doc.setFontSize(10);


            doc.autoTable(columns, this.desserts, { 
        
            startY: 45,
            margin: { top: 25, left: 10 , right: 10},
            styles: { fontSize: 7 }
            
            });



            var finalO =  doc.autoTable.previous.finalY + 30;

            if (finalO >= 285) {
                doc.addPage();
                finalO = 0;
            }



            doc.setFontSize(10);

            doc.text("Observacion:  "+ vm.datos.observa, 10,finalO + 10);


            var finalO1 =  doc.autoTable.previous.finalY + 30;

            if (finalO1 >= 285) {
                doc.addPage();
                finalO1 = 0;
            }

          
            doc.text("Responsable Comercial:  "+ vm.datos.usuario, 10,finalO1 + 20);

           
            finalO = finalO + 40;
        
            
   

            const pageCount = doc.internal.getNumberOfPages();

            for (var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                "Página " + String(i) + " de " + String(pageCount),
                210 - 20,
                297 - 10,
                null,
                null,
                "right"
                );
            }

            doc.save('table.pdf');


       },





    },
  };
  </script>
  
  <style scoped>
  
  </style>
   -->


   <template>
        <v-container fluid class="pa-4 grey lighten-2">

        
            <v-card class="pa-3 mb-4 elevation-2">
            <v-toolbar flat color="white">
                
                <v-toolbar-title class="text-h6 font-weight-bold">
                 Trazabilidad N°   {{ datos.numerot }}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <div class="text-subtitle-1 font-weight-bold">
                N° {{ datos.numerot }}
                </div> -->

                <v-btn icon @click="imprimirPDF_nuevo1" color="primary" class="ml-3">
                <v-icon>mdi-printer</v-icon>
                </v-btn>
            </v-toolbar>
            </v-card>

        
            <v-row dense>
            
            <v-col cols="12" md="4">
                <v-card class="pa-3 elevation-1">
                <div class="grey--text text-caption">Fecha</div>
                <div class="font-weight-medium">
                    {{ datos.fecha }}
                </div>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card class="pa-3 elevation-1">
                <div class="grey--text text-caption">Orden de Compra</div>
                <div class="font-weight-medium">
                    {{ datos.oc }}
                </div>
                </v-card>
            </v-col>

            <v-col cols="12" md="4">
                <v-card class="pa-3 elevation-1">
                <div class="grey--text text-caption">Protocolo</div>
                <div class="font-weight-medium">
                    {{ datos.protocolo }}
                </div>
                </v-card>
            </v-col>

            </v-row>

            <!-- CLIENTE -->
            <v-card class="pa-3 mt-3 elevation-1">
            <div class="grey--text text-caption">Cliente</div>
            <div class="font-weight-medium">
                {{ datos.cliente }}
            </div>
            </v-card>

            <!-- USUARIO -->
            <v-card class="pa-3 mt-3 elevation-1">
            <div class="grey--text text-caption">Usuario</div>
            <div class="font-weight-medium">
                {{ datos.usuario }}
            </div>
            </v-card>

            <!-- TABLA -->
            <v-card class="mt-4 elevation-2">
            <v-card-title class="font-weight-bold">
                Detalle de Materiales
            </v-card-title>

            <v-data-table
                :headers="headers"
                :items="desserts"
                dense
                class="elevation-0"
                :items-per-page.sync="itemsPerPage"
                :footer-props="{
                itemsPerPageText: 'Items por página'
                }"
            >
            </v-data-table>
            </v-card>

        
            <v-card class="pa-3 mt-4 elevation-1">
            <div class="grey--text text-caption">Observación</div>
            <div class="font-weight-medium">
                {{ datos.observa || 'Sin observaciones' }}
            </div>
            </v-card>

        </v-container>
    </template>

    <script>

    import readXlsFile from "read-excel-file";
    import Axios from "../../axios-auth-sistemas";

    import BuscadorClientes from "../Comercial/BuscadorClientes.vue"; 


    import moment from "moment";

    import jsPDF from "jspdf"; 
    import "jspdf-autotable";




    
    export default {

        name:'RemitoLink',

        data() {
            return {
                headers: [
                
                { text: "Serie", value: "serie" },
                { text: "Número", value: "numero" },  
                { text: "Número Recep.", value: "itemr" },        
                { text: "NP", value: "npedido" },
                { text: "Articulo", value: "articulo" },             
            
                ],
            
                excelData: [],
                codigoCli:'',
                nombreCli:'',
                cuitCli:'',
                showBuscadorCli:false,
                showFlags:'',
                CodigoSele:'',
                editMode:false,
                dessertAux:[],
                vAlert:'',
                activar:false,
                validacionExitosa: true, 
                fileInput:'',
                dialogCorreo:false,
                direcciones: [],
                direccion: "",
                correos: "",
                mailSel:"",
                vNumRto:'',
                vRtoGral:'',
                datos:{
                    codigo:'',
                    nombre:'',
                    protocolo:'',
                    numero:'',
                    fecha:'',
                    usuario:'',
                    oc:'', 
                    observa:'',           

                },
                desserts:[],
                visible:true,
                itemsPerPage:-1,




            };
        },


        computed: {

            show: {
                get() {        
        
                return this.visible;
                },
            } 

        },
        watch: {
            
        
        } ,   

        mounted() {

            console.log("estoy en remito link")
                this.vRtoGral = this.$route.query.codgral;
                this.cargarTrazabilidad(this.vRtoGral);

        },


        methods: { 


            salir(){
                this.visible=false;
            },

            cargarTrazabilidad(id){

                console.log("id", id)
                Axios
                .get("/Inspeccion/LinkTrazabilidad?", {
                params: {
                    id: id                 
                },
                })
                .then((r) => { 

                    console.log("datos de la traza ",r.data)

                    

                    this.datos.cliente = r.data[0].cliente;
                    this.datos.protocolo = r.data[0].protocolo==null ||  r.data[0].protocolo=='' ?'Sin Ensayos': r.data[0].protocolo;
                    this.datos.oc = r.data[0].oc;
                    this.datos.fecha = r.data[0].fecha;
                    this.datos.usuario = r.data[0].usuario;
                    this.datos.observa = r.data[0].observa;
                    this.datos.numerot = r.data[0].numerot;
                    

                    r.data.forEach(element => {                   
                        
                        this.desserts.push({
                            numero: element.numero  ,
                            serie: element.serie  ,
                            itemr: element.itemr  ,
                            npedido: element.npedido  ,
                            articulo: element.articulo,
                            id:element.id,
                        

                        })
                    });

                

                

                        
                        
                        
                        
                })
                .catch((error) => {
                    console.log("no muestra el remmito cuando hace link")      
                    
                                
                }); 



            },


            imprimirPDF() {
                const doc = new jsPDF();

            
                // doc.setFontSize(14);
                // doc.text("Reserva de Material", 14, 15);

                doc.setFontSize(14);
                doc.text("Trazabilidad N°: " + (this.datos.numerot || ""), 14, 22);

            
                doc.setLineWidth(0.5);
                doc.line(10, 25, 200, 25);

            
                doc.setFontSize(10);

                doc.text("Fecha: " + (this.datos.fecha ? this.datos.fecha.slice(0,10) : ""), 14, 32);
                doc.text("Orden de Compra: " + (this.datos.oc || ""), 120, 32);

                doc.text("Cliente: " + (this.datos.cliente || ""), 14, 38);
                doc.text("Protocolo: " + (this.datos.protocolo || ""), 14, 44);

                doc.text("Usuario: " + (this.datos.usuario || ""), 120, 44);

            
                const columns = [
                    { title: "Serie", dataKey: "serie" },
                    { title: "Número", dataKey: "numero" },
                    { title: "Recepción", dataKey: "itemr" },
                    { title: "NP", dataKey: "npedido" },
                    { title: "Artículo", dataKey: "articulo" }
                ];

                const rows = this.desserts.map(item => ({
                    serie: item.serie,
                    numero: item.numero,
                    itemr: item.itemr,
                    npedido: item.npedido,
                    articulo: item.articulo
                }));

                const pageWidth = doc.internal.pageSize.getWidth();

                doc.addImage(
                    "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",
                    "JPEG",
                    pageWidth - 20,
                    10,
                    10,
                    10
                );


                doc.autoTable({
                    columns: columns,
                    body: rows,
                    startY: 50,
                    styles: { fontSize: 8 },
                    headStyles: { fillColor: [25, 118, 210] }, // azul lindo
                });

                
                let finalY = doc.lastAutoTable.finalY + 10;

                doc.setFontSize(10);
                doc.text("Observación:", 14, finalY);
                doc.text(this.datos.observa || "Sin observaciones", 14, finalY + 6);

            
                const pageCount = doc.internal.getNumberOfPages();

                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(8);
                    doc.text(
                    "Página " + i + " de " + pageCount,
                    200,
                    290,
                    { align: "right" }
                    );
                }

                
                doc.save("Trazabilidad_" + (this.datos.numerot || "") + ".pdf");


            },


            imprimirPDF_nuevo() {
                const doc = new jsPDF();
                const pageWidth = doc.internal.pageSize.getWidth();

                // 🔷 HEADER
                doc.setFillColor(41, 128, 185);
                doc.rect(0, 0, pageWidth, 25, "F");

                doc.setTextColor(255, 255, 255);
                doc.setFontSize(16);
                doc.text("TRAZABILIDAD", 14, 15);

                doc.setFontSize(12);
                doc.text("N°: " + (this.datos.numerot || ""), 14, 21);

                  doc.addImage(
                    "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",
                    "JPEG",
                    pageWidth - 20,
                    10,
                    10,
                    10
                );


                doc.setTextColor(0, 0, 0);

                // 🔷 DATOS
                let y = 35;

                doc.setFontSize(10);

                doc.text(`Fecha: ${this.datos.fecha || ""}`, 14, y);
                doc.text(`OC: ${this.datos.oc || ""}`, 120, y);

                y += 6;
                doc.text(`Cliente: ${this.datos.cliente || ""}`, 14, y);

                y += 6;
                doc.text(`Protocolo: ${this.datos.protocolo || ""}`, 14, y);
                doc.text(`Usuario: ${this.datos.usuario || ""}`, 120, y);

                // 🔷 COLUMNAS
                const columns = [
                    { title: "Serie", dataKey: "serie" },
                    { title: "Número", dataKey: "numero" },
                    { title: "Recepción", dataKey: "itemr" },
                    { title: "NP", dataKey: "npedido" },
                    { title: "Artículo", dataKey: "articulo" },
                    { title: "Detalle", dataKey: "detalle" }
                ];

                // 🔷 FILAS
                const rows = this.desserts.map(item => ({
                    serie: item.serie || "",
                    numero: item.numero || "",
                    itemr: item.itemr || "",
                    npedido: item.npedido || "",
                    articulo: item.articulo || "",
                    detalle: item.detalle || ""
                }));

                // 🔷 TABLA
                doc.autoTable({
                    columns: columns,
                    body: rows,
                    startY: 55,

                    styles: { 
                        fontSize: 8,
                        cellPadding: 2,
                        valign: "middle"
                    },

                    headStyles: { 
                        fillColor: [41, 128, 185],
                        textColor: 255,
                        fontStyle: "bold"
                    },

                    alternateRowStyles: {
                        fillColor: [245, 245, 245]
                    },

                    columnStyles: {
                        articulo: { cellWidth: 50 },
                        detalle: { cellWidth: 60 }
                    }
                });

                // 🔷 OBSERVACIÓN
                let finalY = doc.lastAutoTable.finalY + 10;

                doc.setDrawColor(200);
                doc.rect(14, finalY, pageWidth - 28, 20);

                doc.setFontSize(9);
                doc.text("Observación:", 16, finalY + 5);

                doc.setFontSize(8);
                doc.text(this.datos.observa || "Sin observaciones", 16, finalY + 10);

                // 🔷 FOOTER
                const pageCount = doc.internal.getNumberOfPages();

                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);

                    doc.setFontSize(8);
                    doc.setTextColor(150);

                    doc.text(
                        `Página ${i} de ${pageCount}`,
                        pageWidth - 10,
                        290,
                        { align: "right" }
                    );

                    doc.text(
                        "Sistema de Trazabilidad",
                        14,
                        290
                    );
                }

                // 🔷 GUARDAR
                doc.save("Trazabilidad_" + (this.datos.numerot || "") + ".pdf");


            },

            imprimirPDF_nuevo1() {
                const doc = new jsPDF();
                const pageWidth = doc.internal.pageSize.getWidth();

                // ── HEADER ──────────────────────────────────────────
                doc.setFillColor(184, 212, 234);        // azul celeste suave
                doc.rect(0, 0, pageWidth, 22, "F");

                doc.setTextColor(20, 20, 20);           // negro
                doc.setFontSize(15);
                doc.setFont("helvetica", "bold");
                doc.text("TRAZABILIDAD", 14, 13);

                doc.setFontSize(9);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(50, 50, 50);
                doc.text("N°: " + (this.datos.numerot || ""), 14, 19);

                // Logo
                doc.addImage(
                    "/9j/4AAQSkZJRgABAQEBLAEsAAD...",  // tu base64 completo acá
                    "JPEG",
                    pageWidth - 20,
                    6, 12, 12
                );

                // Línea decorativa bajo el header
                doc.setFillColor(91, 158, 201);         // azul medio
                doc.rect(0, 22, pageWidth, 2.5, "F");

                // ── DATOS ───────────────────────────────────────────
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(9);
                let y = 33;

                const campo = (label, valor, x, posY) => {
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(100, 100, 100);
                    doc.text(label, x, posY);
                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(30, 30, 30);
                    doc.text(valor || "", x + doc.getTextWidth(label) + 1, posY);
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(0, 0, 0);
                };

                campo("Fecha: ",     this.datos.fecha     || "", 14,  y);
                campo("OC: ",        this.datos.oc        || "", 120, y);  y += 6;
                campo("Cliente: ",   this.datos.cliente   || "", 14,  y);  y += 6;
                campo("Protocolo: ", this.datos.protocolo || "", 14,  y);
                campo("Usuario: ",   this.datos.usuario   || "", 120, y);

                // Título de sección
                y += 10;
                doc.setFontSize(7.5);
                doc.setFont("helvetica", "bold");
                doc.setTextColor(26, 58, 92);
                doc.text("DETALLE DE ARTÍCULOS", 14, y);
                doc.setDrawColor(91, 158, 201);
                doc.setLineWidth(0.5);
                doc.line(14, y + 1.5, pageWidth - 14, y + 1.5);
                doc.setFont("helvetica", "normal");
                doc.setTextColor(0, 0, 0);

                // ── TABLA ───────────────────────────────────────────
                const columns = [
                    { title: "Serie",     dataKey: "serie" },
                    { title: "Número",    dataKey: "numero" },
                    { title: "Recepción", dataKey: "itemr" },
                    { title: "NP",        dataKey: "npedido" },
                    { title: "Artículo",  dataKey: "articulo" },
                    { title: "Detalle",   dataKey: "detalle" }
                ];

                const rows = this.desserts.map(item => ({
                    serie:    item.serie    || "",
                    numero:   item.numero   || "",
                    itemr:    item.itemr    || "",
                    npedido:  item.npedido  || "",
                    articulo: item.articulo || "",
                    detalle:  item.detalle  || ""
                }));

                doc.autoTable({
                    columns,
                    body: rows,
                    startY: y + 5,
                    styles: {
                        fontSize: 8,
                        cellPadding: 3,
                        textColor: [30, 30, 30],
                        lineColor: [210, 210, 210],
                        lineWidth: 0.3
                    },
                    headStyles: {
                        fillColor: [26, 58, 92],        // azul oscuro solo en el header de tabla
                        textColor: [255, 255, 255],
                        fontStyle: "bold",
                        fontSize: 7.5
                    },
                    alternateRowStyles: {
                        fillColor: [244, 247, 251]
                    },
                    columnStyles: {
                        articulo: { cellWidth: 48 },
                        detalle:  { cellWidth: 55 }
                    }
                });

                // ── OBSERVACIÓN ─────────────────────────────────────
                let finalY = doc.lastAutoTable.finalY + 10;

                doc.setDrawColor(180, 180, 180);
                doc.setLineWidth(0.5);
                doc.roundedRect(14, finalY, pageWidth - 28, 22, 2, 2);

                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                doc.setTextColor(60, 60, 60);
                doc.text("Observación:", 18, finalY + 6);

                doc.setFont("helvetica", "normal");
                doc.setTextColor(80, 80, 80);
                doc.text(this.datos.observa || "Sin observaciones", 18, finalY + 13);

                // ── FOOTER ──────────────────────────────────────────
                const pageCount = doc.internal.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setDrawColor(200, 200, 200);
                    doc.setLineWidth(0.3);
                    doc.line(14, 284, pageWidth - 14, 284);

                    doc.setFontSize(7.5);
                    doc.setTextColor(160, 160, 160);
                    doc.text("Sistema de Trazabilidad", 14, 289);
                    doc.text(`Página ${i} de ${pageCount}`, pageWidth - 14, 289, { align: "right" });
                }

                doc.save("Trazabilidad_" + (this.datos.numerot || "") + ".pdf");
            },  


        



        },
    };
    </script>
  
  <style scoped>
  
  </style>
   